/**
 * Progressive-disclosure newsletter form ( front-page industry section ).
 *
 * The form renders collapsed: only the Name and Email fields are visible. The
 * first focus anywhere inside the form expands it to reveal the remaining
 * fields ( Phone, Territory, Role, Industry ) and the submit button. The reveal
 * is one-way — once opened it stays open for the rest of the session, so fields
 * never disappear from under the user.
 *
 * The collapsed / expanded states are driven purely by an `is-expanded` class
 * on the wrapper ( see the CSS in components/front-page/newsletter-form.css );
 * this component only flips `expanded`.
 *
 * Because only Name and Email are required, a collapsed submit normally
 * succeeds. As a safety net, if Gravity Forms returns a validation error into a
 * still-collapsed field, `maybeExpandOnError()` opens the form so the error is
 * visible. The form submits over AJAX, so this is re-checked after each
 * `gform_post_render`.
 *
 * Usage ( emitted by template-parts/front-page/industry.php ):
 *   <div x-data="newsletterForm" x-bind:class="{ 'is-expanded': expanded }"
 *        x-on:focusin="expand( $event )" x-cloak>
 *     … gravity_form() output …
 *   </div>
 */

document.addEventListener( 'alpine:init', () => {

	Alpine.data( 'newsletterForm', () => ({

		expanded: false,

		init() {
			this.maybeExpandOnError();

			// Gravity Forms re-renders the form on AJAX submit; re-check for
			// validation errors that landed in the collapsed region.
			if ( window.jQuery ) {
				window.jQuery( document ).on( 'gform_post_render', () => {
					this.maybeExpandOnError();
				});
			}
		},

		// Links inside the form ( e.g. the privacy-policy link in the consent
		// field ) must navigate, not unfurl. Expanding on their focus reflows
		// the form between mousedown and mouseup, so the click never resolves
		// into a navigation.
		expand( event ) {
			if ( event && event.target.closest( 'a' ) ) {
				return;
			}

			this.expanded = true;
		},

		// Open the form when a validation error is present so the message is
		// never trapped in the collapsed region.
		maybeExpandOnError() {
			if ( this.expanded ) {
				return;
			}

			if ( this.$el.querySelector( '.gfield_error, .gform_validation_errors' ) ) {
				this.expand();
			}
		},

	}) );
});
